// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountTemplate } from './account-template';
import { Admin } from './admin';
import { Asset } from './asset';
import { CurrencyRate } from './currency-rate';
import { Liability } from './liability';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CurrencyType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  currencyTypeId!: number;
  code!: string;
  createdBy!: string;
  createdDate!: Date;
  decimalPlaces!: number;
  description!: string;
  format1!: string;
  format2!: string;
  isSystemBase!: boolean;
  majorUnit!: string;
  minorUnit!: string;
  symbol!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountTemplates!: AccountTemplate[];
  accounts!: Account[];
  admins!: Admin[];
  assets!: Asset[];
  currencyRateFromCurrencyTypeCurrencyTypes!: CurrencyRate[];
  currencyRateToCurrencyTypeCurrencyTypes!: CurrencyRate[];
  liabilities!: Liability[];
}

